<template>
  <PageHeader :pageTitle="pageTitle" />
  <ModalDialog ref="exampleModal">
    <template v-if="cert">
      <p class="mt-3">თქვენ უკვე გაქვთ სერტიფიკატი.</p>
    </template>

    <template v-else>
      <p class="mt-3 mb-2">
        თქვენ სწორად უპასუხეთ {{ totalQuestions }}-დან
        {{ correctAnswers }} შეკითხვას
      </p>
      <p v-if="testPassed && !newCert" class="fw-bold text-danger">
        {{ completedText }}
      </p>
      <p v-if="!testPassed && !newCert" class="fw-bold text-danger">
        თქვენი პასუხები არასწორია, კიდევ სცადეთ
      </p>
    </template>

    <template v-if="newCert">
      <div class="text-center w-100">
        <p class="fw-bold text-danger mt-3 fs-4">გილოცავთ!</p>
        <p class="small mb-2">
          თქვენ დაასრულეთ თანასწორობის უფლების ძირითადი საკითხების შესახებ
          კურსი.
        </p>
        <p class="small mb-2">შეგიძლიათ, ნებისმიერ დროს დაუბრუნდეთ კურსს.</p>
        <p class="small mb-2">
          გვერდის დასაწყისში, ბრაუზერის დაფაზე, "გამოყენებული რესურსები", შეგიძლიათ იხილოთ
          გამოყენებული ლიტერატურა და დამატებითი რესურსები.
        </p>
        <p class="small">თქვენ შეასრულეთ კურსის ყველა მოთხოვნა და მიიღებთ სერტიფიკატს.</p>
      </div>
    </template>

    <template v-slot:footer>
      <template v-if="cert || newCert">
        <div class="text-center w-100">
          <p class="small" style="white-space: nowrap">
            სერტიფიკატის გადმოსაწერად დააჭირეთ ღილაკს "გადმოწერა"
          </p>
          <router-link
            @click="myModal.hide()"
            :to="{ name: 'profile.certificate'}"
            class="btn btn-outline-primary rounded-pill px-4 me-3"
            >გადმოწერა</router-link
          >
        </div>
      </template>

      <template v-else>
        <div v-if="testPassed" class="text-center w-100">
          <p class="small" style="white-space: nowrap">
            კურსის გასაგრძელებლად დააჭირეთ ღილაკს "გაგრძელება"
          </p>
          <router-link
            @click="myModal.hide()"
            :to="{ name: 'section', params: { id: nextSection } }"
            class="btn btn-outline-primary rounded-pill px-4 me-3"
            >გაგრძელება</router-link
          >
        </div>
        <div v-if="!testPassed" class="text-center w-100">
          <p class="small">
            ტესტის თავიდან გასავლელად დააჭირეთ ღილაკს "სცადეთ თავიდან"
          </p>
          <a
            @click="handleTryAgain"
            class="btn btn-outline-primary rounded-pill px-4 me-3"
          >
            სცადეთ თავიდან
          </a>
        </div>
      </template>
    </template>
  </ModalDialog>

  <div class="container mb-5 mt-5">
    <!-- <div v-html="html" class="wysiwyg"></div> -->
    <form @submit.prevent="handleSubmit" action="" v-if="test.questions">
      <div
        v-for="(question, itemObjKey) in test.questions"
        :key="question.id"
        class="mb-5"
      >
        <h5 class="fw-bold mb-3 lh-base">
          {{ itemObjKey + 1 }}. {{ question.title }}
        </h5>
        <div
          v-for="(option, index) in question.decodedOptions"
          :key="index"
          class="form-check mb-2"
        >
          <input
            class="form-check-input"
            type="radio"
            :value="option.value"
            v-model="question.answer"
            :id="'radio-' + question.id + '-' + index"
          />
          <label
            class="form-check-label"
            :for="'radio-' + question.id + '-' + index"
            >{{ option.name }}</label
          >
        </div>
      </div>
      <div class="border p-4 mt-5 rounded">
        <p class="text-center small">
          მოდულის დასასრულებლად დააჭირეთ ღილაკს "დასრულება"
        </p>
        <div class="text-center">
          <router-link
            v-if="prevSection"
            :to="{ name: 'section', params: { id: prevSection } }"
            class="btn btn-outline-primary rounded-pill px-4 me-3"
            >უკან</router-link
          >
          <button
            type="submit"
            class="btn btn-outline-primary rounded-pill px-4"
          >
            დასრულება
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import axios from "@/http";
import { useStore } from "vuex";
import PageHeader from "@/components/PageHeader.vue";
import { Modal } from "bootstrap";
import ModalDialog from "@/components/ModalDialog.vue";
import usePretendFetchData from "@/composables/usePretendFetchData";
import { getCurrentInstance } from "vue";

export default {
  components: { PageHeader, ModalDialog },
  props: ["id"],
  setup(props) {
    const store = useStore();
    const test = ref([]);
    const pageTitle = ref(null);
    const html = ref(null);
    const prevSection = ref(false);
    const nextSection = ref(false);
    const exampleModal = ref(null);
    const completedText = ref(null);

    const totalQuestions = ref(null);
    const correctAnswers = ref(null);
    const testPassed = ref(false);

    const myModal = ref(null);

    const cert = ref(false)
    const newCert = ref(false)

    const internalInstance = getCurrentInstance();

    const setData = (data) => {
      test.value = data;
      html.value = data.body;
      pageTitle.value = data.module.name;
      completedText.value = data.module.completed_text;
      prevSection.value = data.prev_section;
      nextSection.value = data.next_section;
      document.title = `${data.module.name} - ძირითადი საკითხები თანასწორობის უფლების შესახებ`;
    };

    onMounted(async () => {
      // const res = await axios.post(
      //   "getTest",
      //   { id: props.id },
      //   { headers: { Authorization: `Bearer ${store.state.token}` } }
      // );

      // test.value = res.data.data;
      // html.value = res.data.data.body;
      // pageTitle.value = res.data.data.module.name;
      // prevSection.value = res.data.data.prev_section;
      // nextSection.value = res.data.data.next_section;

      // document.title = `${res.data.data.module.name} - ძირითადი საკითხები თანასწორობის უფლების შესახებ`;

      // console.log(exampleModal.value.exampleModalChild);

      myModal.value = new Modal(exampleModal.value.exampleModalChild, {
        backdrop: "static",
        keyboard: false,
      });
    });

    const handleSubmit = async () => {
      internalInstance.appContext.config.globalProperties.$Progress.start();

      const result = test.value.questions.map((question) => {
        if (question.answer === question.correct) return 1;
        else return 0;
      });

      totalQuestions.value = result.length;
      correctAnswers.value = result.filter((el) => el === 1).length;

      const percentage = (correctAnswers.value / totalQuestions.value) * 100;

      if (percentage >= 80) testPassed.value = true;

      // myModal.value.show();

      try {
        const incorrectAnswers = totalQuestions.value - correctAnswers.value;

        const resultObj = test.value.questions.map((question) => {
          return {
            questionId: question.id,
            correctId: question.correct,
            answerId: question.answer ?? 0,
          };
        });

        const payload = {
          userId: store.state.user.id,
          testId: props.id,
          results: resultObj,
          correct: correctAnswers.value,
          incorrect: incorrectAnswers,
          passed: testPassed.value ? 1 : 0
        };
        const res = await axios.post("setTestResults", payload, {
          headers: { Authorization: `Bearer ${store.state.token}` },
        });

        if (!res.data.success) throw new Error(res.data.message);

        cert.value = res.data.cert
        newCert.value = res.data.newCert

        // console.log(cert)
        internalInstance.appContext.config.globalProperties.$Progress.finish();

        myModal.value.show();
      } catch (err) {
        console.log(err.message);
      }
    };

    const handleTryAgain = () => {
      test.value.questions.forEach((question) => {
        question.answer = null;
      });

      myModal.value.hide();
    };

    return {
      handleSubmit,
      test,
      pageTitle,
      html,
      prevSection,
      nextSection,
      exampleModal,
      handleTryAgain,
      totalQuestions,
      correctAnswers,
      testPassed,
      myModal,
      setData,
      completedText,
      cert,
      newCert
    };
  },
  beforeRouteEnter(to, from, next) {
    usePretendFetchData("getTest", to.params.id, (data) => {
      next((vm) => vm.setData(data));
    });
  },
  beforeRouteUpdate(to, from, next) {
    usePretendFetchData("getSection", to.params.id, (data) => {
      this.setData(data);
      next();
    });
  },
};
</script>

<style>
</style>